function headerInit() {
  let header = document.querySelector('.header');
  let headerHamburger = document.querySelector('.header__hamburger');
  let headerMenu = document.querySelector('.header__menu');
  let headerMenuLink = document.querySelectorAll('.header__menu-link');

  headerHamburger.addEventListener('click', () => {
    headerHamburger.classList.toggle('is-active');
    headerMenu.classList.toggle('is-active');
  })

  headerMenu.addEventListener('click', () => {
    headerMenu.classList.remove('is-active');
    headerHamburger.classList.remove('is-active');
  })

  headerMenuLink.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      let start = link.href.indexOf('#')
      let id = link.href.slice(start)
      let section = document.querySelector(id)

      window.scrollTo({
        top: section.offsetTop - header.clientHeight,
        left: 0,
        behavior: 'smooth'
      })
    })
  })

  window.addEventListener('scroll', () => {
    if (document.documentElement.scrollTop > 0) {
      header.classList.add('is-active')
    } else {
      header.classList.remove('is-active')
    }
  })
}

export { headerInit }